import leftBorder from './leftBorder.json';
import simple from './simple.json';

export default { leftBorder, simple };
